import { Box, Header, Link } from "@cloudscape-design/components";

const GitHubLinks = () => 
  ""
  // <Box>
  //   <Header variant="h3">General information</Header>
  //   <ul>
  //     <li>
  //       <b>UCI Student AWS Accounts</b> on GitHub
  //       <Link href="#" external />
  //     </li>
  //     <li>
  //       <b>
  //         UCI Student AWS Accounts<sup>TM</sup>
  //       </b>{" "}
  //       on GitHub
  //       <Link href="#" external />
  //     </li>
  //   </ul>
  // </Box>

export default GitHubLinks;
